import clsx from 'clsx';
import { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material';
import styles from './Filters.module.scss';
import { Button, Input, Select } from 'tt-ui-lib/core';
import { CALC_TYPES } from 'utils/calculatorUtils';
import ClearIcon from '@mui/icons-material/Clear';

const CustomizedAccordion = styled(Accordion)(() => ({
  '&.MuiAccordion-root': {
    // borderRadius: '16px',
    width: '100%',
    // boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.04)',
    // padding: '10px 24px',
  },
  boxShadow: 'none',
}));

const Filters = (props) => {
  const { countries, industryGroups, subIndustry, filter, calcType, setFilter } = props;

  const onValueChange = (value, type) => {
    setFilter({ ...filter, [type]: value });
  };

  const clearFilter = () => {
    setFilter({});
  };

  return (
    <div style={{ width: '100%' }}>
      <CustomizedAccordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{ padding: '0px', margin: '0px' }}
        >
          <div className={styles.summary}>
            <img src="/images/templates/Filters.png" alt="Filters" />
            <h1 className={styles.title}>Filters</h1>
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: '0px', margin: '0px' }}>
          <div className={styles.accordionDetails}>
            <div className={styles.filterBlock}>
              <div className={styles.filterInput}>
                {calcType === CALC_TYPES.GLOBAL ? (
                  <Select
                    label="Sub Industry"
                    name="subIndustry"
                    onChange={(value) => onValueChange(value, 'subIndustry')}
                    value={filter.subIndustry ?? ''}
                    options={subIndustry}
                  />
                ) : (
                  <Select
                    label="Industrial group"
                    name="industry"
                    onChange={(value) => onValueChange(value, 'industry')}
                    value={filter.industry ?? ''}
                    options={industryGroups}
                  />
                )}
              </div>
              <div className={styles.filterInput}>
                <Select
                  label="Countries"
                  name="country"
                  onChange={(value) => onValueChange(value, 'country')}
                  value={filter.country ?? ''}
                  options={countries}
                />
              </div>
              <div className={styles.filterInput}>
                <div className={styles.BlockNumber}>
                  Employees
                  <div>
                    <Input
                      placeholder="from"
                      onChange={(value) => onValueChange(value, 'min')}
                      value={filter.min ?? ''}
                      // inputProps={{ maxLength: 10, type: 'number' }}
                    />
                    <Input
                      placeholder="to"
                      onChange={(value) => onValueChange(value, 'max')}
                      value={filter.max ?? ''}
                      // inputProps={{ maxLength: 10, type: 'number' }}
                    />
                  </div>
                </div>
              </div>
              <Button type="icon" onClick={clearFilter}>
                <ClearIcon />
              </Button>
            </div>
          </div>
        </AccordionDetails>
      </CustomizedAccordion>
    </div>
  );
};

export default Filters;
